import { Grid, Stack, Typography } from '@mui/material';
import { CompanyRole } from 'tdc-web-backend/enums/enums';
import { useTranslation } from 'react-i18next';
import ControlledTextInput from '../../../../components/custom-inputs/ControlledTextInput';

import { primaryDark, secondaryBlue } from '../../../../utils/color';
import CustomTooltip from '../../../../components/tooltip/CustomTooltip';
import { ReactComponent as InfoIcon } from '../../../../assets/icons/info.svg';

interface CompanyInformationAccordionProps {
  disabled: boolean;
  userType: CompanyRole | undefined;
}

const CompanyIdTooltip = () => {
  const { t } = useTranslation();
  return (
    <CustomTooltip title={t('contracts.companyIdentificationNumberInfo')}>
      <InfoIcon
        fill={primaryDark[500]}
        style={{
          marginLeft: '14px',
        }}
      />
    </CustomTooltip>
  );
};

const CompanyInformationForm = ({ disabled, userType }: CompanyInformationAccordionProps) => {
  const { t } = useTranslation();
  return (
    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={3}>
      <Grid
        sx={{
          borderRight: `1px solid ${secondaryBlue[100]}`,
          pr: 2.5,
          pb: 4,
        }}
        item
        xs={6}
      >
        <Stack spacing={2}>
          <Typography
            color="primaryDark.600"
            variant="heading4"
            sx={{
              pb: 2,
            }}
          >
            {t('common.client')}
          </Typography>
          <Stack sx={{ marginTop: '0 !important' }}>
            <Stack spacing={4}>
              <Stack spacing={4}>
                <ControlledTextInput
                  name="body.buyer.companyName"
                  disabled={disabled}
                  placeholder={`${t('common.enter')} ${t('common.companyName').toLowerCase()}`}
                  label={t('common.companyName')}
                  required
                />
                <ControlledTextInput
                  name="body.buyer.registeredAddress"
                  disabled={disabled}
                  label={t('common.registeredAddress')}
                  placeholder={`${t('common.enter')} ${t(
                    'common.registeredAddress',
                  ).toLowerCase()}`}
                  required
                />
                <ControlledTextInput
                  name="body.buyer.companyNumber"
                  disabled={disabled}
                  label={t('common.companyIdentificationNumber')}
                  placeholder={`${t('common.enter')} ${t(
                    'common.companyIdentificationNumber',
                  ).toLowerCase()}`}
                  required
                  labelAdornment={<CompanyIdTooltip />}
                />
              </Stack>
              <Stack spacing={1.5}>
                <Stack spacing={0.5}>
                  <Typography
                    color="primaryDark.600"
                    variant="heading4"
                    sx={{
                      pb: 2,
                    }}
                  >
                    {t('contracts.companyRepresentative')}
                  </Typography>
                </Stack>
                <Stack spacing={4} sx={{ marginTop: '0 !important' }}>
                  <ControlledTextInput
                    name="body.buyer.companyRepresentative.name"
                    disabled={disabled}
                    label={t('common.fullName')}
                    placeholder={`${t('common.enter')} ${t('common.fullName').toLowerCase()}`}
                    required
                  />
                  <ControlledTextInput
                    name="body.buyer.companyRepresentative.jobTitle"
                    disabled={disabled}
                    label={t('common.jobTitle')}
                    placeholder={`${t('common.enter')} ${t('common.jobTitle').toLowerCase()}`}
                    required
                  />
                  <ControlledTextInput
                    name="body.buyer.companyRepresentative.email"
                    disabled={disabled}
                    label={t('common.officialEmail')}
                    placeholder={`${t('common.enter')} ${t('common.officialEmail').toLowerCase()}`}
                    required
                  />
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Grid>
      <Grid
        item
        xs={6}
        sx={{
          pl: 1.25,
          pb: 4,
        }}
      >
        <Stack spacing={2}>
          <Typography
            color="primaryDark.600"
            variant="heading4"
            sx={{
              pb: 2,
            }}
          >
            {t('common.supplier')}
          </Typography>

          <Stack sx={{ marginTop: '0 !important' }}>
            <Stack spacing={4}>
              <Stack spacing={4}>
                <ControlledTextInput
                  name="body.seller.companyName"
                  disabled={disabled}
                  label={t('common.companyName')}
                  placeholder={`${t('common.enter')} ${t('common.companyName').toLowerCase()}`}
                  required
                />
                <ControlledTextInput
                  name="body.seller.registeredAddress"
                  disabled={disabled}
                  label={t('common.registeredAddress')}
                  placeholder={`${t('common.enter')} ${t(
                    'common.registeredAddress',
                  ).toLowerCase()}`}
                  required
                />
                <ControlledTextInput
                  name="body.seller.companyNumber"
                  disabled={disabled}
                  label={t('common.companyIdentificationNumber')}
                  placeholder={`${t('common.enter')} ${t(
                    'common.companyIdentificationNumber',
                  ).toLowerCase()}`}
                  required
                  labelAdornment={<CompanyIdTooltip />}
                />
              </Stack>
              <Stack spacing={1.5}>
                <Stack spacing={0.5}>
                  <Typography
                    color="primaryDark.600"
                    variant="heading4"
                    sx={{
                      pb: 2,
                    }}
                  >
                    {t('contracts.companyRepresentative')}
                  </Typography>
                </Stack>
                <Stack spacing={4} sx={{ marginTop: '0 !important' }}>
                  <ControlledTextInput
                    name="body.seller.companyRepresentative.name"
                    disabled={disabled}
                    label={t('common.fullName')}
                    placeholder={`${t('common.enter')} ${t('common.fullName').toLowerCase()}`}
                    required
                  />
                  <ControlledTextInput
                    name="body.seller.companyRepresentative.jobTitle"
                    disabled={disabled}
                    label={t('common.jobTitle')}
                    placeholder={`${t('common.enter')} ${t('common.jobTitle').toLowerCase()}`}
                    required
                  />
                  <ControlledTextInput
                    name="body.seller.companyRepresentative.email"
                    disabled={disabled}
                    label={t('common.officialEmail')}
                    placeholder={`${t('common.enter')} ${t('common.officialEmail').toLowerCase()}`}
                    required
                  />
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default CompanyInformationForm;
